/**
 * Column widths of the Redshift `events` table that every logEvent lands in,
 * in bytes of UTF-8 (Redshift declares VARCHAR(n) in bytes).
 *
 * Canonical copy: packages/server/cdk/lambda/shared/eventColumnLimits.js, with
 * the DDL in packages/server/redshift-queries/{dev,stage,prod}/events.sql.
 * packages/server/cdk/test/qa-report-data-events.test.ts parses this file and
 * fails if it drifts from the DDL.
 *
 * The client does not check events against these before sending: the
 * logEvent resolver rejects an over-wide field (InvalidEventInput), and that
 * is enough. They are here for the emitters that shape their own values to
 * fit, such as reportRoute.ts capping a report slug at `what_id`.
 */
export const EVENT_COLUMN_LIMITS = {
  time_id: 12,
  who_id: 512,
  what_id: 64,
  event_type: 50,
  result: 20,
  product: 64,
} as const;
